import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/utils/button';
import { controls as config } from 'config';
import storage from 'utils/data/storage';
import layout from 'utils/layout';

const propTypes = {
  enabled: PropTypes.bool,
};

const defaultProps = {
  enabled: false,
};

const Download = () => {
  if (!layout.control && config.swap && !layout.single) return null;

  return (
    <a href={'https://dl.bbb.iut.ac.ir/record/' + storage.metadata.id + '.mp4'} target="_blank">
      <Button
          circle
          handleOnClick={() => {}}
          icon="download"
      />
    </a>
  );
};

Download.propTypes = propTypes;
Download.defaultProps = defaultProps;

export default Download;
